export type UseTwitterSEOProps = {
  enabled: boolean;
  cardFormat?: 'app' | 'player' | 'summary' | 'summary_large_image'; 
  creatorUsername?: string;
  description?: string;
  imageUrl?: string;
  siteUsername?: string;
  title?: string;
  url?: string
}

export function useTwitterSEO({ enabled, cardFormat, creatorUsername, description, imageUrl, siteUsername, title, url }: UseTwitterSEOProps) {
  if (!enabled) {
    return <></>
  }

  let twitterSite;
  if (url && url.includes('popular')) {
    twitterSite = '@jornal_opopular'
  } else if (url && url.includes('tocantins')) {
    twitterSite = '@jornaltocantins'
  } else if (url && url.includes('daqui')) {
    twitterSite = '@meudaqui'
  }
    
  return (
    <>
      {cardFormat && <meta key='twitter_card' name='twitter:card' content={cardFormat} />}
      {creatorUsername && <meta key='twitter_creator' name='twitter:creator' content={creatorUsername} />}
      {description && <meta key='twitter_description' name='twitter:description' content={description} />}
      {siteUsername && <meta key='twitter_site' name='twitter:site' content={siteUsername} />}
      {title && <meta key='twitter_title' name='twitter:title' content={title} />}
      {imageUrl && <meta key='twitter_image' name='twitter:image' content={imageUrl} />}
      <meta key='twitter:site' name='twitter:site' content={twitterSite} />
    </>
  )
}